import b from 'b_';
import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Link from '../../link/link';

import './table__row.scss';

// не используем функциональный компонент, чтобы можно было навешивать ref-ы на ряды
class TableRow extends React.Component {
    static propTypes = {
        children: PropTypes.node,
        contentMix: PropTypes.string,
        disabled: PropTypes.bool,
        linkTo: PropTypes.string,
        mix: PropTypes.string,
        onClick: PropTypes.func,
        onHover: PropTypes.func,
        onHoverEnd: PropTypes.func,
    };

    render() {
        const { children, contentMix, disabled, linkTo, onClick, mix, onHover, onHoverEnd } = this.props;

        let rowContent = <div className={cx('table__row-content', contentMix)}>{children}</div>;

        if (linkTo) {
            rowContent = (
                <Link disabled={disabled} isRouter mix="table__row-link" theme={Link.THEME.ABSTRACT} to={linkTo}>
                    {rowContent}
                </Link>
            );
        }

        return (
            <div
                className={cx(b('table', 'row', { disabled }), mix)}
                onClick={onClick}
                onMouseEnter={onHover}
                onMouseLeave={onHoverEnd}
            >
                {rowContent}
            </div>
        );
    }
}

export default TableRow;
